// src/components/AboutPage.jsx

import aboutImage from '../Images/about-us.png'; // 1. Import the new image
import SEOHelmet from './SEOHelmet';

function AboutPage() {
  return (
    <>
      <SEOHelmet
        title="About Us - Our Mission & Philosophy | Torque Energy"
        description="Learn about Torque Energy's mission and philosophy. We're dedicated to providing clean energy and peak performance solutions without compromise."
        keywords="about torque energy, mission, philosophy, energy drink company, our story, clean energy"
        url="https://torqueenergy.shop/about"
      />
      <div className="container about-page-container">
        {/* Section 1: Main Header */}
        <div className="about-header">
          <h2>Our Mission is Your Momentum.</h2>
          <p className="about-subtitle">
            We're not just another energy drink. We're the fuel for your ambition.
          </p>
        </div>

        {/* Section 2: Two-Column Grid Layout */}
        <div className="about-grid">
          <div className="about-image-column">
            <img src={aboutImage} alt="Healthy and energetic lifestyle" />
          </div>
          <div className="about-text-column">
            <h3>Clean Energy, Peak Performance</h3>
            <p>
              Born from a passion for performance and health, Torque Energy was founded on a simple principle: to fuel your goals without compromise. We saw a world of energy drinks filled with artificial ingredients and sugar crashes, and we knew there was a better, cleaner way.
            </p>
          </div>
        </div>

        {/* Section 3: Full-Width Text */}
        <div className="about-philosophy">
          <h3>The Torque Philosophy</h3>
          <p>
            Each can and bottle of Torque is meticulously crafted with premium, effective ingredients designed to enhance focus, sustain energy, and support your body's needs. We believe in transparent labels and powerful results.
          </p>
          <p className="tagline">
            <strong>Torque – Drive Your Day!</strong>
          </p>
        </div>
      </div>
    </>
  );
}

export default AboutPage;